module.exports = __webpack_public_path__ + "img/hugo-pro.f42f6a5c.jpg";